import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import posthog_client_rllYZRHHNj from "/app/node_modules/nuxt-posthog/dist/runtime/plugins/posthog.client.js";
import _0_siteConfig_MwZUzHrRNP from "/app/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_zbacBAXhj0 from "/app/.nuxt/modules/@nuxt-scripts/plugin.mjs";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import directives_RRqu2cLOwC from "/app/node_modules/nuxt-posthog/dist/runtime/plugins/directives.js";
import nuxt_plugin_6wEQMY3tee from "/app/node_modules/nuxt-delay-hydration/dist/runtime/nuxt-plugin.js";
import plugin_C2QvvtgUo3 from "/app/node_modules/@dargmuesli/nuxt-cookie-control/dist/runtime/plugin.js";
import i18n_yfWm7jX06p from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import plugin_eskviOYyLt from "/app/node_modules/nuxt-vue3-google-signin/dist/runtime/plugin.mjs";
import plugin_t2GMTTFnMT from "/app/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import img_slider_client_452taEIy7v from "/app/aihd-base-nuxt/plugins/img-slider.client.ts";
import _0_refresh_token_palUSNG4eY from "/app/plugins/0.refresh-token.ts";
import _1_firebase_client_b4vTDHWvku from "/app/plugins/1.firebase.client.ts";
import VueLottie_client_GW2BVrEJ8y from "/app/plugins/VueLottie.client.ts";
import ga4_analytics_client_4RjcFmKfRt from "/app/plugins/ga4-analytics.client.ts";
import mit_Q5SeSqvoJ4 from "/app/plugins/mit.ts";
import public_api_9PoNh1mDMC from "/app/plugins/public-api.ts";
import pusher_client_No5cywskfC from "/app/plugins/pusher.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  posthog_client_rllYZRHHNj,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_zbacBAXhj0,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  directives_RRqu2cLOwC,
  nuxt_plugin_6wEQMY3tee,
  plugin_C2QvvtgUo3,
  i18n_yfWm7jX06p,
  plugin_eskviOYyLt,
  plugin_t2GMTTFnMT,
  chunk_reload_client_UciE0i6zes,
  img_slider_client_452taEIy7v,
  _0_refresh_token_palUSNG4eY,
  _1_firebase_client_b4vTDHWvku,
  VueLottie_client_GW2BVrEJ8y,
  ga4_analytics_client_4RjcFmKfRt,
  mit_Q5SeSqvoJ4,
  public_api_9PoNh1mDMC,
  pusher_client_No5cywskfC
]